import './src/styles/global.css'
import Layout from './src/components/layout'

// Wraps every page in a component, see gatsby-ssr.js
export const wrapPageElement = Layout
